import React, { useState } from "react";
import PropTypes from "prop-types";

import Modal from "@shared/v2/Modal";
import Button from "@shared/v2/Button";

import PersonDetailError from "../PersonDetailError";


const DeleteAddressModal = ({ show, onClose, onSubmit, address }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const onCloseHandler = () => {
    setError(null);
    setIsLoading(false);
    onClose();
  };

  return (
    <Modal
      className="tw-flex tw-items-center tw-justify-center"
      show={show}
      onHide={onCloseHandler}
      contentClassName="tw-w-[467px] tw-flex tw-flex-col tw-gap-[32px]"
    >
      <Modal.Header
        title="Delete Address?"
        closeButton
      />
      <Modal.Body className='tw-flex tw-flex-col tw-gap-[32px] tw-text-14d tw-text-gray-75'>
        {error && <PersonDetailError error={error} errorTitle={null} />}

        <div>
          Are you sure you want to delete <b>{address}</b>?
        </div>
        <div>Deleting this address will remove it from the lead’s PDP. This may affect other features that rely on the user’s address.</div>
      </Modal.Body>
      <Modal.Footer className="tw-flex tw-flex-row tw-justify-between">
        <Button schema="tertiary" size="medium" onClick={onCloseHandler}>
          Cancel
        </Button>
        <Button isLoading={isLoading} schema="warning" size="medium" onClick={async () => {
          setIsLoading(true);

          const response = await onSubmit();
          setIsLoading(false);

          if (response.error) {
            setError(response.error);
            return;
          }

          onCloseHandler();
        }}>
          Yes, delete
        </Button>
      </Modal.Footer>
    </Modal>

  )
};

export default DeleteAddressModal;

DeleteAddressModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  address: PropTypes.string.isRequired,
  onSubmit: PropTypes.func,
  show: PropTypes.bool,
}

DeleteAddressModal.defaultProps = {
  onSubmit: null,
  show: false,
};
